import { createContext, useContext } from "react";

interface DeepLinkingContextProps {
  markPostLoginReadyForDeepLinks: () => void;
  resetDeepLinkingOnLogout: () => void;
}

const DeepLinkingContext = createContext<DeepLinkingContextProps | undefined>(
  undefined,
);

const useDeepLinkingContext = (): DeepLinkingContextProps => {
  const context = useContext(DeepLinkingContext);
  if (!context) {
    throw new Error(
      "useDeepLinkingContext must be used within a DeepLinkingProvider",
    );
  }
  return context;
};

export { DeepLinkingContext, useDeepLinkingContext };
